var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKasta(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#621EFD"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.286 6.857H6v5.1l2.323-2.529h1.963l-2.751 3l2.751 3H8.323L6 12.895v2.533H4.286zm15 9a1.286 1.286 0 1 0 0-2.571a1.286 1.286 0 0 0 0 2.57"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M17.143 15.857v-3.214c0-1.072-.617-3.215-3.085-3.215c-2.756 0-3.343 2.439-3.343 3.215c0 .925.514 3.214 2.901 3.214c1.397 0 1.774-1.033 1.813-1.183v1.183zm-3.214-1.714a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKasta);
export default __webpack_public_path__ + "static/media/kasta.7ff95152d1d41df0a1583ded7f2400ac.svg";
export { ForwardRef as ReactComponent };